/*
 * Tips for using the editor.
 */

import __ from './../utils/translation';


export const editorTips = [
  __('Tip: use arrows to move a selected object by 1 pixel!'),
  __('Tip: Shift + Click to select and modify multiple objects!'),
  __('Tip: hold Shift when rotating an object for 15° angle jumps!'),
  __('Tip: hold Shift when drawing a line for 15° angle jumps!')
]
